import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { useMountEffect } from "primereact/hooks";
import { Field } from "react-final-form";
import { resetState } from "../../../store/slices/authSlice";
import { TextInput } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import PreLoginContainer from "../../common/preLoginContainer";
import { useNavigate, useSearchParams } from "react-router-dom";

const Login = ({ requesting, action, resetState }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useMountEffect(() => {
    resetState();
  });

  const userName =
    (searchParams.get("params") &&
      atob(decodeURIComponent(searchParams.get("params")))) ||
    null;

  return (
    <PreLoginContainer showLoginMessage={true}>
      <div className="title text-center">
        {intl.formatMessage({
          id: "sign_in",
        })}
      </div>
      <Form
        initialValues={{
          username: userName || Cookies.get("username") || "",
        }}
        fullWidthButtons
        requesting={action === "sign-in" && requesting}
        submitBtn={{
          label: intl.formatMessage({
            id: "sign_in_password",
          }),
          icon: "pi-arrow-right",
          onClick: (values) => {
            navigate(RouteConstants.APP_ROUTE_LOGIN_LOCAL, {
              state: { username: values.username },
            });
          },
        }}
        extraBtn={{
          label: intl.formatMessage({
            id: "sign_in_otp",
          }),
          shouldValidate: true,
          icon: "pi-arrow-right",
          onClick: (values) => {
            navigate(RouteConstants.APP_ROUTE_OTP, {
              state: { username: values.username },
            });
          },
        }}
      >
        <div className="flex flex-column gap-2 mt-4">
          <Field
            name="username"
            component={TextInput}
            type="text"
            icon="pi-user"
            placeholder={intl.formatMessage({
              id: "username",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
        </div>
      </Form>
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
  global: state.global,
});

const mapDispatchToProps = (dispatch) => ({
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
